import { createEnvelopeSource } from './create-envelope-source';

/**
 * Coupons-redeemed KPI source. Pure config over the standardized envelope
 * (`GET /analytics/coupons/redeemed-rpp`): one scalar count of ACTIVE activations
 * on RPP promotions, plus a `businessUnit` and a `province` breakdown of it.
 *
 * The mirror of `coupon-issued`, and deliberately so: same window convention,
 * same RPP-registration province source, so `couponsRedeemedRpp` and
 * `couponsIssuedRpp` line up region by region and can be read as one funnel.
 *
 * Not to be confused with `coupon-activation`'s `claimed`, which is the
 * non-RPP complement of this metric (its query hardcodes `is_for_rpp = false`)
 * rather than a superset. The two never overlap.
 *
 * Total-only: the endpoint declares `capabilities.daily=false`, so no `line`
 * form here.
 */
export const couponRedeemedRppSource = createEnvelopeSource({
    label: 'RPP coupons redeemed',
    endpoint: 'analytics/coupons/redeemed-rpp',
    metrics: [
        {
            id: 'couponsRedeemedRpp',
            label: 'RPP coupons redeemed',
            type: 'scalar',
        },
    ],
    forms: ['number', 'bars', 'pie'],
    regionGrain: 'province',
});
